// Dependencies
import React, { useState } from "react";

// Material UI Components
import Container from "@mui/material/Container";

// Components
import VideoCard from "components/video/VideoCard/VideoCard.component";

// Helpers

// Styles
import PropTypes from "prop-types";
import { useStyles } from "./VideoGallery.styles";
import VideoThumbnail from "../VideoThumbnail/VideoThumbnail.component";

const VideoGallery = ({ videos }) => {
  const classes = useStyles();
  const [videoIndex, setVideoIndex] = useState(0);

  const unselected = videos.filter((_, index) => index !== videoIndex);

  return (
    <Container
      maxWidth="lg"
      className={classes.videoGalleryContainer}
      data-component="VideoGallery"
    >
      <div className={classes.galleryContainer}>
        <div className={classes.mainVideoContainer}>
          <VideoCard
            key={videos[videoIndex].url}
            medium={videos[videoIndex]}
            dataCy="main-video-card"
          />
        </div>
        {unselected.length > 0 && (
          <div className={classes.thumbnailColumn}>
            {unselected.map((medium) => (
              <VideoThumbnail
                key={`video-gallery-thumbnail-${medium.id}`}
                medium={medium}
                index={videos.indexOf(medium)}
                setIndex={setVideoIndex}
              />
            ))}
          </div>
        )}
      </div>
    </Container>
  );
};

export default VideoGallery;

VideoGallery.propTypes = {
  videos: PropTypes.shape([
    {
      id: PropTypes.number,
      createdAt: PropTypes.string,
      mediumType: PropTypes.string,
      modelId: PropTypes.number,
      path: PropTypes.string,
      updatedAt: PropTypes.string,
      url: PropTypes.string,
    },
  ]).isRequired,
};

VideoGallery.defaultProps = {};
